module.exports = __webpack_public_path__ + "static/media/May.ab658fac.PNG";